import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import { Facebook2, Instagram2, Messeges2,WebsiteIcon} from "./Icon";
import { TokenItem } from "./Launchpad";
import MarqueeSection from "./MarqueeSection";
import TokenChart2 from "./TokenChart2";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAnchorWallet } from '@solana/wallet-adapter-react';
import * as anchor from '@project-serum/anchor';
import idl from '../assets/IDL/idl.json';
import toast, { Toaster } from 'react-hot-toast';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons'; // For website icon
import { faBook } from '@fortawesome/free-solid-svg-icons'; // For documentation
import { faCopy } from '@fortawesome/free-solid-svg-icons'; // For documentation

import { faTwitter, faTelegramPlane } from '@fortawesome/free-brands-svg-icons'; // For Twitter and Telegram

import CountdownCard from "./Countdown";
import ReactSelectSearch from 'react-select-search';
import 'react-select-search/style.css'



const PROGRAM_ID = 'HfotedVpaC45b87hS5QZGpUxn87tg9uHRZeFxDGnD5NP';
const RPC_URL = `https://mainnet.helius-rpc.com/?api-key=${process.env.REACT_APP_API_KEY}`;
const PRESALE_SEED = "sol244";
const WHITELIST_SEED = "white244";
const TARGET_LAUNCH_DATE = new Date(Date.UTC(2024, 10, 11, 20, 0, 0));

// Create a default connection outside component to use when wallet isn't connected
const defaultConnection = new anchor.web3.Connection(RPC_URL, 'confirmed');



const WhitelistSearch = React.memo(({ options }) => {
	const [searchTerm, setSearchTerm] = useState('');
	const [copiedIndex, setCopiedIndex] = useState(null);

	const filteredAddresses = useMemo(() =>
	  options.filter(option =>
		option.value.toLowerCase().includes(searchTerm.toLowerCase())
	  ),
	  [options, searchTerm]
	);

	const handleCopy = useCallback((index) => {
	  setCopiedIndex(index);
	  setTimeout(() => setCopiedIndex(null), 2000);
	}, []);

	return (
	  <div className="inner-div">
		{/* <div
		  className="mb-4 p-4"
		  style={{
			background: '#2c2d33',
			borderRadius: '8px',
			color: '#fff',
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center'
		  }}
		>
		  <span style={{ fontSize: '16px', fontWeight: '500' }}>Total Whitelisted Addresses</span>
		  <span
			style={{
			  fontSize: '18px',
			  fontWeight: '600',
			  color: '#90EE90',
			  background: '#1a1b23',
			  padding: '8px 16px',
			  borderRadius: '6px'
			}}
		  >
			{options.length}
		  </span>
		</div> */}

		<div className="mb-4">
		  <input
			type="text"
			className="form-control poppins"
			placeholder="Search addresses..."
			value={searchTerm}
			onChange={(e) => setSearchTerm(e.target.value)}
			style={{
			  background: '#1a1b23',
			  border: '1px solid #2c2d33',
			  borderRadius: '8px',
			  color: '#fff',
			  padding: '12px 16px',
			  '::placeholder': { color: '#6c757d' },
			}}
		  />
		  <style>
			{`
			  .form-control {
				color: #fff !important;
			  }
			  .form-control::placeholder {
				color: #6c757d !important;
			  }
			`}
		  </style>
		</div>

		<div
		  className="whitelist-addresses"
		  style={{
			maxHeight: '400px',
			overflowY: 'auto',
			background: '#1a1b23',
			borderRadius: '8px',
			padding: '16px'
		  }}
		>
		  {filteredAddresses.length > 0 ? (
			<ul className="list-unstyled m-0">
			  {filteredAddresses.map((address, index) => (
				<li
				  key={`${address.value}-${index}`}
				  className="mb-2 p-3 d-flex justify-content-between align-items-center"
				  style={{
					background: '#2c2d33',
					borderRadius: '6px',
					fontSize: '14px',
					wordBreak: 'break-all',
					color: '#fff'
				  }}
				>
				  <span style={{ flex: 1 }}>{address.value}</span>
				  <CopyToClipboard
					text={address.value}
					onCopy={() => handleCopy(index)}
				  >
					<button
					  className="btn btn-sm ms-2"
					  style={{
						background: 'transparent',
						border: 'none',
						padding: '4px 8px',
						color: copiedIndex === index ? '#90EE90' : '#fff',
						cursor: 'pointer',
						transition: 'color 0.3s ease'
					  }}
					>
					  <FontAwesomeIcon
						icon={faCopy}
						size="1x"
					  />
					</button>
				  </CopyToClipboard>
				</li>
			  ))}
			</ul>
		  ) : (
			<div className="text-center py-4" style={{ color: '#fff' }}>
			  No addresses found
			</div>
		  )}
		</div>
	  </div>
	);
  });

const TokenDetailsSection3 = () => {
		// State Management
		const [tab, setTab] = useState("overview");
		const [copied, setCopied] = useState(false);
		const [amount, setAmount] = useState('');
		const [currentContribution, setCurrentContribution] = useState(0);
		const [maxPoolSize, setMaxPoolSize] = useState(0);
		const [totalContributed, setTotalContributed] = useState(0);
		const [options, setOptions] = useState([]);
		const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
		const [isLaunched, setIsLaunched] = useState(true);
		const [isLoading, setIsLoading] = useState(false);

		// Wallet Setup
		const wallet = useAnchorWallet();

		// Program Setup - Works with or without wallet
		const getProgram = useCallback(() => {
			try {
			if (wallet) {
				const provider = new anchor.AnchorProvider(
				defaultConnection,
				wallet,
				anchor.AnchorProvider.defaultOptions()
				);
				return new anchor.Program(idl, PROGRAM_ID, provider);
			} else {
				// Create a read-only provider when wallet isn't connected
				const provider = new anchor.AnchorProvider(
				defaultConnection,
				// Create a dummy wallet for read-only operations
				{
					publicKey: anchor.web3.PublicKey.default,
					signTransaction: () => Promise.reject(),
					signAllTransactions: () => Promise.reject(),
				},
				{ commitment: 'confirmed' }
				);
				return new anchor.Program(idl, PROGRAM_ID, provider);
			}
			} catch (error) {
			console.error('Error creating program:', error);
			return null;
			}
		}, [wallet]);

		// Data Fetching Functions
		const fetchPresaleData = useCallback(async () => {
			const program = getProgram();
			if (!program) return;

			try {
			const [presaleAccountPda] = await anchor.web3.PublicKey.findProgramAddress(
				[Buffer.from(PRESALE_SEED)],
				program.programId
			);

			const presaleAccountInfo = await program.account.presaleAccount.fetch(presaleAccountPda);

			// Update states with new data
			setMaxPoolSize(presaleAccountInfo.maxPoolSize.toNumber() / anchor.web3.LAMPORTS_PER_SOL);
			setTotalContributed(presaleAccountInfo.totalContributed.toNumber() / anchor.web3.LAMPORTS_PER_SOL);

			} catch (error) {
			console.error('Error fetching presale data:', error);
			}
		}, [getProgram]);

		const memoizedOptions = useMemo(() => options, [options]);

		// Modify the fetchWhitelist function to prevent unnecessary updates
		const fetchWhitelist = useCallback(async () => {
			const program = getProgram();
			if (!program) return;

			try {
			const [whitelistPda] = await anchor.web3.PublicKey.findProgramAddress(
				[Buffer.from(WHITELIST_SEED)],
				program.programId
			);

			const whitelistAccountInfo = await program.account.whitelistAccount.fetch(whitelistPda);

			const newOptions = whitelistAccountInfo.whitelistedAddresses.map(address => ({
				name: address.toString(),
				value: address.toString()
			}));

			// Only update if the data has actually changed
			setOptions(prevOptions => {
				const prevOptionsString = JSON.stringify(prevOptions);
				const newOptionsString = JSON.stringify(newOptions);

				if (prevOptionsString !== newOptionsString) {
				return newOptions;
				}
				return prevOptions;
			});

			} catch (error) {
			console.error('Error fetching whitelist data:', error);
			}
		}, [getProgram]);

		// Only fetch current contribution when wallet is connected
		const fetchCurrentContribution = useCallback(async () => {
			if (!wallet) {
			setCurrentContribution(0);
			return;
			}

			const program = getProgram();
			if (!program) return;

			try {
			const [presaleAccountPda] = await anchor.web3.PublicKey.findProgramAddress(
				[Buffer.from(PRESALE_SEED)],
				program.programId
			);

			const presaleAccountInfo = await program.account.presaleAccount.fetch(presaleAccountPda);
			const userContribution = presaleAccountInfo.contributions.find(
				contribution => contribution.user.toString() === wallet.publicKey.toString()
			);

			if (userContribution) {
				setCurrentContribution(userContribution.amount.toNumber() / anchor.web3.LAMPORTS_PER_SOL);
			} else {
				setCurrentContribution(0);
			}
			} catch (error) {
			console.error('Error fetching current contribution:', error);
			setCurrentContribution(0);
			}
		}, [wallet, getProgram]);

		// Setup Auto-Refresh
		useEffect(() => {
			// Initial fetch
			const fetchAll = async () => {
			setIsLoading(true);
			try {
				// Always fetch these regardless of wallet connection
				await Promise.all([
				fetchPresaleData(),
				fetchWhitelist()
				]);

				// Only fetch current contribution if wallet is connected
				if (wallet) {
				await fetchCurrentContribution();
				}
			} catch (error) {
				console.error('Error in initial fetch:', error);
			} finally {
				setIsLoading(false);
			}
			};

			fetchAll();

			// Set up intervals
			const intervals = [
			{ fn: fetchPresaleData, time: 5000 },
			{ fn: fetchWhitelist, time: 10000  }
			];

			// Add contribution interval only if wallet is connected
			if (wallet) {
			intervals.push({ fn: fetchCurrentContribution, time: 10000 });
			}

			// Create all intervals
			const intervalIds = intervals.map(({ fn, time }) =>
			setInterval(fn, time)
			);

			// Cleanup function
			return () => intervalIds.forEach(clearInterval);
		}, [wallet, fetchPresaleData, fetchWhitelist, fetchCurrentContribution]);

		// Countdown Timer Effect
		useEffect(() => {
			const timer = setInterval(() => {
			const now = new Date().getTime();
			const difference = TARGET_LAUNCH_DATE.getTime() - now;

			if (difference <= 0) {
				setIsLaunched(true);
				clearInterval(timer);
				return;
			}

			setCountdown({
				days: Math.floor(difference / (1000 * 60 * 60 * 24)),
				hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
				minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
				seconds: Math.floor((difference % (1000 * 60)) / 1000)
			});
			}, 1000);

			return () => clearInterval(timer);
		}, []);

		// Transaction Handler
		const handleContribute = async (e) => {
			e.preventDefault();

			if (!wallet) {
			toast.error('Please connect your wallet to contribute');
			return;
			}

			if (!amount || amount <= 0) {
			toast.error('Please enter a valid amount');
			return;
			}

			// Validate amount is exactly 10 SOL
			if (!amount || Number(amount) !== 10) {
				toast.error('Contribution amount must be exactly 10 SOL');
				return;
			}

			setIsLoading(true);
			try {
			const program = getProgram();
			if (!program) return;

			const amountLamports = new anchor.BN(amount * anchor.web3.LAMPORTS_PER_SOL);

			const [presaleAccountPda] = await anchor.web3.PublicKey.findProgramAddress(
				[Buffer.from(PRESALE_SEED)],
				program.programId
			);

			const [whitelistAccountPda] = await anchor.web3.PublicKey.findProgramAddress(
				[Buffer.from(WHITELIST_SEED)],
				program.programId
			);

			await program.methods
				.contribute(amountLamports)
				.accounts({
				presaleAccount: presaleAccountPda,
				user: wallet.publicKey,
				whitelistAccount: whitelistAccountPda,
				systemProgram: anchor.web3.SystemProgram.programId,
				})
				.rpc();

			toast.success(`Successfully contributed ${amount} SOL`);
			setAmount('');

			// Refresh data after contribution
			await Promise.all([
				fetchPresaleData(),
				fetchCurrentContribution()
			]);

			} catch (error) {
			handleContributionError(error);
			} finally {
			setIsLoading(false);
			}
		};

		// Error Handler
		const handleContributionError = (error) => {
			const errorMessages = {
			NotWhitelisted: 'Your address is not whitelisted',
			MaxBuyExceeded: 'Maximum buy amount exceeded',
			PoolLimitReached: 'Pool limit reached',
			InvalidAmount: 'Invalid contribution amount',
			PresaleInactive: 'Presale is not active'
			};

			for (const [key, message] of Object.entries(errorMessages)) {
			if (error.message?.includes(key)) {
				toast.error(message);
				return;
			}
			}

			toast.error('Transaction failed. Please try again.');
		};




		const handleAmountChange = (e) => {
			setAmount(e.target.value);
		};


		const notifySuccess = (min) => {
			toast.success('Successfully Contributed'+" "+min+"SOL");
		};
		const notifyfailed = () => {
			toast.error('ERROR');
		};










	return (
		<><Toaster
		position="top-center"
		reverseOrder={false}
		gutter={8}
		containerClassName=""
		containerStyle={{}}
		toastOptions={{
		  // Define default options
		  className: 'sfprotext-semi-bold-violet-20px',
		  duration: 5000,
		  style: {
			background: '#90EE90', /* Black background */
			color: '#000000', /* Light green text */
		},

		  // Default options for specific types
		  success: {
			duration: 3000,
			theme: {
			  primary: 'green',
			  secondary: 'black',
			},
		  },
		}}
	  />
		<section className="token-details-section">
			<MarqueeSection />
			<div className="pt-5">
				<div className="container poppins">
					<div className="d-flex flex-wrap gap-4 justify-content-center justify-content-sm-start gap-xl-57">
						<div className="bigger-block">
							<div className="token-details poppins">
								<div
									className="token-details-top"
									style={{
										background: `url('/img/octo99.png') center top -40px / cover`,
									}}
								>
								<div className="w-100" style={{ backgroundColor: "#000", padding: "10px" }}>
									<div className="d-flex align-items-center justify-content-between" style={{ marginBottom: "10px" }}>
										<div className="d-flex align-items-center gap-3">
										<div
											style={{
												borderRadius: "50%",
												border: "4px solid",
												borderImage: "linear-gradient(135deg, #8e44ad, #3498db) 1",
												padding: "5px",
												width: "70px",
												height: "70px",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												backgroundColor: "#000"
											}}
										>
											<img className="img" src={"/img/octo400.png"} alt="" width={50} />
										</div>
										<h6 style={{ color: "#fff", fontSize: "1.5rem", margin: 0 }}>OctonetAI</h6>
										</div>
										<div className="d-flex gap-2">
										<Link to="https://www.octonet.ai/">
											<div className="icon-block globe-icon">
											<FontAwesomeIcon size="lg" icon={faGlobe} style={{ color: "#000" }} />
											</div>
										</Link>
										<Link to="https://x.com/octonetai">
											<div className="icon-block twitter-icon">
											<FontAwesomeIcon size="lg" icon={faTwitter} style={{ color: "#000" }} />
											</div>
										</Link>
										<Link to="https://t.me/OctonetAiChannel">
											<div className="icon-block telegram-icon">
											<FontAwesomeIcon size="lg" icon={faTelegramPlane} style={{ color: "#000" }} />
											</div>
										</Link>
										<Link to="https://docs.octonet.ai/">
											<div className="icon-block book-icon">
											<FontAwesomeIcon size="lg" icon={faBook} style={{ color: "#000" }} />
											</div>
										</Link>
										</div>
									</div>
									<style>
										{`
										.icon-block {
											width: 40px;
											height: 40px;
											display: flex;
											justify-content: center;
											align-items: center;
											background: linear-gradient(135deg, #8e44ad, #3498db);
											border-radius: 10px;
											transition: transform 0.3s ease, box-shadow 0.3s ease;
										}
										.icon-block:hover {
											transform: scale(1.1);
											box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
										}
										@media (max-width: 768px) {
											.icon-block {
											width: 20px;
											height: 20px;
											}
											.icon-block .fa-lg {
											font-size: 0.75em;
											}
										}
										`}
									</style>
									</div>
								</div>
								<div className="token-details-bottom">
									<div className="token-details-tabs mb-4">
										<button
											type="button"
											className={`tab-btn ${
												tab === "overview" ? "active" : ""
											}`}
											onClick={() => setTab("overview")}
										>
											<span>Overview</span>
										</button>
										<button
											type="button"
											className={`tab-btn ${
												tab === "tokenomics" ? "active" : ""
											}`}
											onClick={() => setTab("tokenomics")}
										>
											<span>Tokenomics</span>
										</button>
										<button
											type="button"
											className={`tab-btn ${
												tab === "info-stats" ? "active" : ""
											}`}
											onClick={() => setTab("info-stats")}
										>
											<span>Whitelists</span>
										</button>
									</div>
									{tab === "overview" ? (
										<div className="inner-div">
											<div className="kyc-button-tags position-relative justify-content-start p-0">
												<span className="kyc-button-tag">KYC</span>
												{/* <span className="kyc-button-tag">
													Audit
												</span> */}
												<span className="kyc-button-tag">Safu</span>
												<span className="kyc-button-tag">Tech</span>
											</div>
											{/* <h5>Presale Address</h5>
											<h6 className="text-16 font-semibold">
											HSn2hT7mFEKj9FwSvq6qXZqgSW41d1U92UFQkANLC1tC
												</h6>
											<iframe
												width="630"
												height="321"
												src="https://www.youtube.com/embed/isFB5Tk6kPo?si=fXtJZLvk7cTuKjka"
												title="Solana Update"
												frameborder="0"
												allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
												allowfullscreen
												className="mb-3"
											></iframe> */}
											<p className="text-60">
											At OctonetAI, we are committed to revolutionizing the way developers, businesses, and researchers access and utilize artificial intelligence.

Powered by the Solana blockchain, our innovative platform offers a comprehensive suite of AI and machine learning solutions designed for scalability, speed,
and affordability.

From pre trained models to high performance GPU rentals, OctonetAI is your gateway to unlocking the full potential of AI technology.

Join us in shaping the future of AI-driven applications and discover the possibilities that OctonetAI can bring to your projects											</p>
										</div>
									) : tab === "tokenomics" ? (
                                        <div className="inner-div">
                                          <TokenChart2 />
                                          <div className="tokenomics-table" style={{
                                            background: '#1a1b23',
                                            borderRadius: '12px',
                                            padding: '24px',
                                            marginTop: '24px',
                                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                                          }}>
                                            <table style={{
                                              width: '100%',
                                              borderCollapse: 'separate',
                                              borderSpacing: '0 8px'
                                            }}>
                                              <tbody>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    width: '40%',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Token Name
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    OctonetAI
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Token Symbol
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    $OCTO
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Total Supply
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    100,000,000 (100M)
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#808080',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '8px 0 0 8px',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle',
                                                    fontWeight: '500'
                                                  }}>
                                                    Liquidity Pool
                                                  </td>
                                                  <td style={{
                                                    padding: '16px 24px',
                                                    color: '#fff',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    background: '#2c2d33',
                                                    borderRadius: '0 8px 8px 0',
                                                    textAlign: 'center',
                                                    verticalAlign: 'middle'
                                                  }}>
                                                    50% of SOL raised
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>

                                            <div style={{
                                              marginTop: '24px',
                                              padding: '16px 24px',
                                              background: '#2c2d33',
                                              borderRadius: '8px',
                                              color: '#fff',
                                              fontSize: '14px',
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: '12px'
                                            }}>
                                              <div style={{
                                                minWidth: '8px',
                                                height: '8px',
                                                borderRadius: '50%',
                                                backgroundColor: '#90EE90'
                                              }}></div>
                                              <span style={{ lineHeight: '1.5' }}>
                                                50% of the SOL raised from the presale will be allocated for the Liquidity Pool (LP) and locked in streamflow finance
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : tab === "info-stats" ? (
                                        <WhitelistSearch options={options} />
                                    ) : null}
								</div>
							</div>
						</div>
						<div className="smaller-block">
							<div
								style={{ maxWidth: "378px" }}
								className="mx-auto me-lg-0"
							>
							<div style={{ maxWidth: "313px" }} className="mx-auto">
							<div className="__progress-item">
								<label className="form-label">WL Presale</label>
								<div className="__progress">
								<div
									className="progress-bar"
									style={{ width: `${(totalContributed / maxPoolSize) * 100}%` }}
								></div>
								</div>
								<div className="d-flex justify-content-between mt-10">
								<span>
									{totalContributed} / {maxPoolSize} SOL
									</span>
									<div>
									<span style={{ color: '#6366f1' }}>{((totalContributed / maxPoolSize) * 100).toFixed(2)}%</span>
									<span className="text-sm">Current Progress</span>
								</div>
								</div>
							</div>

							{isLaunched ? (
							// Buy Form
							<form className="mb-5"  onSubmit={handleContribute}>
								<div className="max-buy-form">
								<div className="input position-relative">
									<input
									type="number"
									className="form-control poppins"
									id="max"
									placeholder="0"
									value={amount}
									onChange={handleAmountChange}
									/>
									<label htmlFor="max" className="amount">
									amount
									</label>
								</div>
								<button type="submit" className="btn-base">Buy</button>
								</div>
							</form>
							) : (
							// Timer Design
							<button className="secondary-btn" type="button" style={{
								background: '#1a1a1a',
								border: 'none',
								borderRadius: '12px',
								padding: '16px',
								width: '100%',
								marginTop: '20px'
							}}>
								<div className="d-flex flex-column align-items-center gap-2">
								<span className="text-18 font-regular text-white">
									Starts in
								</span>

									<div className="countdown-container">
									<div className="time-segment days">
										<span className="time-value">
										{String(countdown.days).padStart(2, '0')}
										</span>
										<span className="time-label">d</span>
									</div>

									<div className="time-segment hours">
										<span className="time-value">
										{String(countdown.hours).padStart(2, '0')}
										</span>
										<span className="time-label">h</span>
									</div>

									<div className="time-segment minutes">
										<span className="time-value">
										{String(countdown.minutes).padStart(2, '0')}
										</span>
										<span className="time-label">m</span>
									</div>

									<div className="time-segment seconds">
										<span className="time-value">
										{String(countdown.seconds).padStart(2, '0')}
										</span>
										<span className="time-label">s</span>
									</div>
									</div>
								</div>
							</button>
							)}

							<div className="custom-container">
								{currentContribution !== 0 && (
								<p className="custom-text">
									Your Contribution: {currentContribution} SOL
								</p>
								)}
							</div>
							<br></br>
							</div>
								<div className="raise-details">
									<h5 className="title">Raise Details</h5>
									{/* <p>Token Presale Address</p>

									<CopyToClipboard text={value} onCopy={() => setCopied(true)}>
										<button className="copyButton">HSn2hT7mFEKj9FwSvq6qXZqgSW41d1U92UFQkANLC1tC</button>
									</CopyToClipboard>


									{copied ? <span style={{ marginLeft: '10px' }}>Copied!</span> : null} */}

									<br></br>
									<div className="raise-area">
									<div className="raise-item">
											<h6 className="subtitle">TOKEN NAME</h6>
											<span className="subtext">OctonetAI</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">TOKEN SYMBOL</h6>
											<span className="subtext">$OCTO</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">MIN BUY</h6>
											<span className="subtext">10 SOL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">MAX BUY</h6>
											<span className="subtext">10 SOL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">SOFTCAP</h6>
											<span className="subtext">1000 SOL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">HARDCAP</h6>
											<span className="subtext">2000 SOL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">TOKEN TYPE</h6>
											<span className="subtext">SPL</span>
										</div>
										<div className="raise-item">
											<h6 className="subtitle">WL </h6>
											<span className="subtext">True</span>
										</div>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="pt-5">
				{/* <div className="container pt-lg-4">
					<h2 className="font-medium slider-title">
						Live and Upcoming token sales
					</h2>

					<div className="row g-4">
						{data?.map((item, i) => (
							<TokenItem key={i} item={item} i={i} />
						))}
					</div>
				</div> */}
			</div>
		</section>
		</>
	);
};

const data = [
	{
		img: "/img/mockimg.png",
		authorImg: "/img/logo3.png",
		date: "12 Aug 2024",
	},
	{
		img: "/img/mockimg.png",
		authorImg: "/img/logo3.png",
		live: true,
	},
	{
		img: "/img/mockimg.png",
		authorImg: "/img/logo3.png",
		live: true,
	},

];
export const chartdata = [
	{ name: "Mark", value: 90 },
	{ name: "Robert", value: 12 },
	{ name: "Emily", value: 34 },
];

export default TokenDetailsSection3;
